import { Stack } from "./Stack";

/**
 * Zásobník, který poskytuje metodu pro nahlížení na prvky pod vrcholem zásobníku
 */
export class TransparentStack<T> extends Stack<T> {
    //#region Methods
    constructor(sourceIterator?: Iterable<T>) {
        super();

        if (sourceIterator) {
            for (const item of sourceIterator) {
                this.push(item);
            }
        }
    }

    public *getIterator(): IterableIterator<T> {
        for (let i = 0; i < this._internalStack.length; ++i) {
            yield this._internalStack[i];
        }
    }

    /**
     * Nahlíží na prvky zásobníku pod vrcholem
     * @param depth Pořadí prvku pod vrcholem zásobníku
     */
    public override peek(depth: number = 0): T | null {
        const stackLength = this._internalStack.length;
        return (stackLength > 0 && stackLength > depth) ? this._internalStack[stackLength - 1 - depth] : null;
    }
    //#endregion Methods
}
